import React, { useEffect } from "react";
import PageShell from "../components/sections/PageShell";

/**
 * Shared shell for /privacy and /terms pages.
 * Uses the canonical PageShell (Navigation + Footer) and provides a
 * restrained legal heading + readable prose container.
 */
export default function LegalPage({ title, updated, description, children, canonicalPath, testId }) {
  useEffect(() => {
    document.title = `${title} — Gadget Guy Media`;
    window.scrollTo(0, 0);
    const setMeta = (attr, key, value) => {
      let el = document.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", value);
    };
    const setLink = (rel, href) => {
      let el = document.querySelector(`link[rel="${rel}"]`);
      if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", rel);
        document.head.appendChild(el);
      }
      el.setAttribute("href", href);
    };
    setMeta("name", "description", description);
    setMeta("property", "og:title", `${title} — Gadget Guy Media`);
    setMeta("property", "og:description", description);
    setLink("canonical", `https://gadgetguymedia.com${canonicalPath}`);
    return () => setLink("canonical", "https://gadgetguymedia.com/");
  }, [title, description, canonicalPath]);

  return (
    <PageShell testId={testId}>
      <section
        className="max-w-3xl mx-auto px-5 md:px-8"
        style={{
          paddingTop: "clamp(40px, 6vh, 80px)",
          paddingBottom: "clamp(24px, 4vh, 48px)",
        }}
      >
        <div className="ggm-eyebrow mb-4">Legal</div>
        <h1
          className="font-condensed font-bold text-white"
          style={{ fontSize: "clamp(2rem, 4.5vw, 3.25rem)", lineHeight: 1.05, letterSpacing: "-0.02em" }}
        >
          {title}
        </h1>
        <p className="mt-4 font-condensed uppercase tracking-widest text-xs text-white/40">
          Last updated: {updated}
        </p>
      </section>

      <section className="max-w-3xl mx-auto px-5 md:px-8" style={{ paddingBottom: "clamp(64px, 10vh, 140px)" }}>
        <div className="ggm-legal-prose font-body text-white/75 leading-relaxed text-base space-y-6">
          {children}
        </div>
      </section>
    </PageShell>
  );
}
